import { render, staticRenderFns } from "./MaterialityHeader.vue?vue&type=template&id=6a28bb4c"
import script from "./MaterialityHeader.vue?vue&type=script&lang=js"
export * from "./MaterialityHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports